import { tap } from './functional-utils';
export const PIPE_RETURN_SYMBOL = Symbol('PIPE_RETURN');
export function createPipeReturn(value) {
    return { kind: PIPE_RETURN_SYMBOL, value };
}
function isPipeReturn(value) {
    return (value !== null &&
        typeof value === 'object' &&
        'kind' in value &&
        value.kind === PIPE_RETURN_SYMBOL);
}
export function catcher(handler) {
    const catchFn = (input) => {
        return input;
    };
    catchFn._tag = 'catcher';
    catchFn._handler = handler;
    return catchFn;
}
export function catchType(errorType, handler) {
    const catchFn = (input) => {
        return input;
    };
    catchFn._tag = 'catchType';
    catchFn._targetError = errorType;
    catchFn._handler = handler;
    return catchFn;
}
export function createPipeThrow(error) {
    throw error;
}
const isCatchFunction = (step) => typeof step === 'function' &&
    '_tag' in step &&
    (step._tag === 'catcher' || step._tag === 'catchType');
const isCatchTypeFunction = (catchFn) => catchFn._tag === 'catchType';
const runSyncPipe = (initialValue, ...steps) => {
    let currentValue = initialValue;
    let lastSuccessfulValue = initialValue;
    let currentError = null;
    for (let i = 0; i < steps.length; i++) {
        const step = steps[i];
        if (isPipeReturn(currentValue)) {
            return currentValue.value;
        }
        try {
            if (isCatchFunction(step)) {
                if (currentError !== null) {
                    if (isCatchTypeFunction(step)) {
                        if (!(currentError instanceof step._targetError)) {
                            continue;
                        }
                    }
                    const result = step._handler(currentError, lastSuccessfulValue);
                    currentError = null;
                    if (!isPipeReturn(result)) {
                        lastSuccessfulValue = result;
                    }
                    currentValue = result;
                    if (isPipeReturn(currentValue)) {
                        return currentValue.value;
                    }
                }
                else {
                    currentValue = step(currentValue);
                }
            }
            else {
                if (currentError === null) {
                    lastSuccessfulValue = currentValue;
                    currentValue = step(currentValue);
                    if (isPipeReturn(currentValue)) {
                        return currentValue.value;
                    }
                }
            }
        }
        catch (error) {
            currentError = error;
        }
    }
    if (currentError !== null) {
        throw currentError;
    }
    return currentValue;
};
export function syncPipe(a, ...args) {
    return runSyncPipe(a, ...args);
}
syncPipe.catch = catcher;
syncPipe.catchType = catchType;
syncPipe.return = createPipeReturn;
syncPipe.throw = createPipeThrow;
syncPipe.debug = (label = '') => tap((value) => {
    const debugLabel = label || `syncPipe: ${value}`;
    debugger;
});
export const pipe = syncPipe;
export { runSyncPipe };
//# sourceMappingURL=syncPipe.js.map